import React, { useState, useMemo, useRef, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { useDispatch, useSelector } from 'react-redux';
import TableFilters from '../../../Components/common/TableGrid/TableFilters'
import { useRegionsQuery } from '../../../redux/services/SRC'
import TableGrid from "../../../Components/common/TableGrid";

import { ReactComponent as EditIcon } from "../../../assets/images/settings_icon/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/images/settings_icon/delete.svg";
import { ReactComponent as SaveIcon } from "../../../assets/images/save.svg";
import { CallApi, CommonModal } from '../../../Components/common/CommonFunctions';
import { MultiSelect } from 'react-multi-select-component';
import { toast } from 'react-toastify';
import { STATIONLIST } from '../../../Utils/conts';
import ConfModal from '../../../Components/common/ConfModal';

const Regions = () => {

  const isMounted = useRef(false);
  const [addModal, setAddModal] = useState(false)
  const [modalConf, setModalConf] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [stations, setStations] = useState([])
  const [position, setPosition] = useState('')
  const [formData, setFormData] = useState({})
  const handleAdd = (pos, dta) => {
    if (pos === 'E') {
      setFormData(dta)
    } else {
      setFormData({})
    }
    setPosition(pos)
    setAddModal(true)
  }
  const modalClose = () => {
    setAddModal(false)
  }
  const HandleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }
  const handleSave = () => {
    CallApi({
      endPoint: 'setting/add-update',
      payload: { ...formData, region_type: 'service_recovery' },
      onSuccess: (res) => {

        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg)
          refetch()
          setFormData({})
          setAddModal(false);
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }

  const fetchStation = () => {
    CallApi({
      endPoint: STATIONLIST,
      onSuccess: (res) => {
        const innerData = res.data.response_data.map(i => ({
          label: i.port_code,
          value: i.port_code,
        }));
        setStations(innerData)
      },
      onError: (msg) => toast.error(msg)
    });
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchStation();
    isMounted.current = true;
  }, []);

  const filtersConfig = [
    {
      type: "button",
      text: "Add Region",
      click: () => handleAdd('A'),
      icon: 'plus',
      class: 'create_btn'

    },
  ];

  const columns = [
    {
      label: "", field: "actions", enableSearch: false, cls: "tw-2",
      renderCell: (row) => (
        <div className="tb_grid_actions">
          <EditIcon className="row_view" style={{ cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              handleAdd('E', row)
            }} />
          <DeleteIcon className="row_msg" style={{ cursor: "pointer", marginLeft: "6px" }}
            onClick={(e) => {
              e.stopPropagation();
              deleteRegion(row)
              if (row) {

              }

            }} />
        </div>
      ),
    },
    { label: 'Region Name', field: 'region_name', cls: "tw-3" },
    { label: 'Region Code', field: 'region_code', cls: "tw-3" },
    {
      label: 'Assigned Stations', field: 'station',
      renderCell: (row) => {
        return row?.station?.join(', ');
      },
    },
  ];

  const { pageDetails, filters, sortby, selectedRows, tab } = useSelector((state) => state.table);

  const queryParams = useMemo(() => {
    // const filterParams = buildFilterParams(filters);
    const params = {
      // station_id: propData?.station_id,
      // ...filterParams,
      pagenum: pageDetails.pagenum,
      pagesize: pageDetails.pagesize,
    };
    if (sortby?.sortdatafield) {
      params.sortdatafield = sortby.sortdatafield;
      params.sortorder = sortby.sortorder;
    }
    return params;
  }, [filters, pageDetails, sortby]);
  const { data: myData, isFetching, refetch } = useRegionsQuery(queryParams, {
    skip: pageDetails.pagesize === 0,
    refetchOnMountOrArgChange: true,
  });

  const deleteRegion = (dta) => {
    setDeleteId(dta?.id)
    setModalConf(true)
  }
  const handleConfDelete = () => {
    CallApi({
      endPoint: 'setting/delete-restore',
      payload: { id: deleteId },
      onSuccess: (res) => {

        if (res.data.response_code === 200) {
          toast.success(res.data.response_msg)
          refetch()
          setModalConf(false);
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => toast.error(msg)
    });
  }

  return (
    <>
      {console.log('fd', formData)}

      {modalConf &&
        <ConfModal
          header={`Delete Region`}
          subHeader={`Are you sure you want to delete this Region?`}
          modalConf={() => handleConfDelete()}
          closeModal={() => setModalConf(false)}
          primaryBtn='Delete'
          secondaryBtn='Cancel'
        />
      }

      <div>
        <h4>Regions</h4>
        <p>Create and manage operational regions used for automatic assignment and ownership of recovery records.</p>
      </div>
      <hr />
      <div className="d-flex mb-3">
        <TableFilters filtersConfig={filtersConfig} />
       </div>
      <div className='setting_table'>
        <TableGrid
          columns={columns}
          rows={myData?.Rows}
          checkboxSelection={true}
          // totalRecords={propData?.address?.length || 0}
          // onClickRow={(row) => handleRowClick(row)}
          // loading={isFetching}
          rowKey='handler_contact_id'
        // bulkActions={bulkActions}
        />
      </div>
      {addModal &&
        <CommonModal
          show={addModal}
          onHide={modalClose}
          title={`${position === 'E' ? 'Default' : 'Default'}  Routing Rules`}
          subTitle={`${position === 'E' ? 'Manage automatic' : 'Manage automatic'} region assignment rules.`}
          className='modal_bgw primary_modal'
          footer={
            <div className='d-flex justify-content-between'>
              <div></div>
              <Button variant="primary" className='defult_save' onClick={handleSave}><SaveIcon /> {position === 'E' ? 'Update' : 'Save'} </Button>
            </div>
          }>
          <Row>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Region Name</Form.Label>
                <Form.Control
                  type='text'
                  placeholder="Region Name"
                  name="region_name"
                  value={formData.region_name}
                  onChange={HandleChange}
                />
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group>
                <Form.Label>Region Code</Form.Label>
                <Form.Control
                  type='text'
                  placeholder="Region Code"
                  name="region_code"
                  value={formData.region_code}
                  onChange={HandleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group>
            <Form.Label>Assigned Stations</Form.Label>
            <MultiSelect
              options={stations}
              value={stations.filter(option => formData.station?.includes(option.value)) || ''}
              onChange={(selected) => {
                const updatedData = { ...formData, station: selected ? selected.map(option => option.value) : [] };
                setFormData(updatedData);
              }}
              labelledBy="Assigned Stations "
              className='multiselect'
            />
          </Form.Group>
        </CommonModal>
      }
    </>
  )
}

export default Regions